import { useIntl } from "react-intl";
import {
  getIndustrySpecialistFormSchema,
  IndustrySpecialistFormData,
} from "./create-industry-specialist.schema";
import { FormProvider, useForm } from "react-hook-form";
import BaseInput from "pages/admin-app/shared/components/BaseInput";
import BaseButton from "components/common/BaseButton";
import { zodResolver } from "@hookform/resolvers/zod";

interface Props {
  onSubmit: (data: IndustrySpecialistFormData) => void;
  isSubmitting: boolean;
}

const CreateIndustrySpecialistForm = ({ onSubmit, isSubmitting }: Props) => {
  const intl = useIntl();
  const industrySpecialistForm = getIndustrySpecialistFormSchema(intl);

  const methods = useForm({
    resolver: zodResolver(industrySpecialistForm),
  });

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="inputs-container">
        <BaseInput
          name="name"
          label={intl.formatMessage({ id: "usAdmin.name" })}
          type="text"
          containerClassName="usadmin-input-name"
        />
        <BaseInput
          name="email"
          label={intl.formatMessage({ id: "usAdmin.email" })}
          type="text"
          containerClassName="usadmin-input-contactName"
        />
        <BaseButton
          text={intl.formatMessage({ id: "usAdmin.create" })}
          type="submit"
          disabled={isSubmitting}
          className="first-column usadmin-form-submit-button"
          handleSubmit={() => {}}
        />
      </form>
    </FormProvider>
  );
};

export default CreateIndustrySpecialistForm;
